export function createLabel(developerId: number): string {
  return `/sale/JK/object_type=2/spec=company/${developerId}/from_developer=1/repres=0/owner=0/pod_snos=0`;
}
